import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../modules';
import { RequestHtml } from '../../modules/editor';
import { requestContainer, requestContents, requestEmail, requestGenerateHtml } from '../../modules/editor/service';

type Props = {
};

function SaveTemplate({ }: Props) {
  const { token, account } = useSelector((state: RootState) => state.auth);
  const container = useSelector((state: RootState) => state.editor.container);

  const save = async () => {
    const emailId = Number(window.location.pathname.replace('/editor/', ''));
    const email = await requestEmail(emailId);
    const imageFilename = email.subjectA?.split('(')[1].replace(')', '');
    const filename = email.subjectA?.split(']')[0].replace('[', '');

    const contents: any = await requestContents(emailId);
    const container: any = await requestContainer(emailId);

    const styleData = {
      thumbnail: `https://qa-resource.stibee.com/templates/thumbnail/${imageFilename}.png`,
      container: container,
    }

    var data = JSON.stringify(contents.data, undefined, 4)
    var blob = new Blob([data], { type: 'text/json' }),
      e = document.createEvent('MouseEvents'),
      a = document.createElement('a')
    a.download = `${filename}.json`;
    a.href = window.URL.createObjectURL(blob)
    a.dataset.downloadurl = ['text/json', a.download, a.href].join(':')
    e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
    a.dispatchEvent(e);

    const htmlData: RequestHtml = {
      emailId: emailId,
      auth: {
        token: token || '',
        account: account
      },
      data: {
        contents: contents.data,
        container: container
      },
      isNoneUnsub: false,
      option: 'normal',
      previewText: '',
      templateId: email.templateId,
    }

    const html = await requestGenerateHtml(htmlData, { newHtmlRendering: account.options.newHtmlRendering });

    var blob1 = new Blob([html], { type: 'text/json' }),
      e1 = document.createEvent('MouseEvents'),
      a1 = document.createElement('a')
    a1.download = `${filename}.html`;
    a1.href = window.URL.createObjectURL(blob1)
    a1.dataset.downloadurl = ['text/json', a1.download, a1.href].join(':')
    e1.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
    a1.dispatchEvent(e1);

  }

  return (
    <>
      <button className="btn medium" onClick={save}>템플릿 json 다운로드</button>
    </>
  );
}

SaveTemplate.defaultProps = {
};

export default SaveTemplate;